import type { OptionProps } from 'react-select';
import classnames from 'classnames';
import type { IReactSelectOptions } from '../interfaces/reactSelectOptions';

export function SelectOption(props: OptionProps<IReactSelectOptions, false>) {
    return (
        <div
            className={classnames('Select__option', props.data.className, {
                'option--is-disabled': props.isDisabled,
                'option--is-selected': props.isSelected,
                'option--is-focused': props.isFocused,
            })}
            ref={props.innerRef}
            {...props.innerProps}
        >
            {props.children}
        </div>
    );
}
